/*var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

document.querySelectorAll(".wishlist").forEach((wishlistButton) => {
  wishlistButton.addEventListener("click", function () {
    this.classList.toggle("active");
  });
});


*/


/*Search*/

                
/* Custom Slider For Banner Collections*/

document.addEventListener('DOMContentLoaded',() => {
  if(window.matchMedia("(max-width:920px)").matches){
      let desktopRatingWrapper = document.querySelector("#shopify-product-reviews.hide-mobile");

      if(desktopRatingWrapper){ desktopRatingWrapper.remove()}

         window.SPR?.initRatingHandler();
         window.SPR?.initDomEls();
         window.SPR?.loadProducts();
         window.SPR?.loadBadges();
  }
})


if(document.querySelector(".doSliderCustomCollections"))
{
  $(".doSliderCustomCollections")
  .slick({
    slidesToShow: 4,
    cellAlign: 'left',
    slidesToScroll: 3,
    arrows: false,
    centerMode: false,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: false,
          centerPadding: '40px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ],
    nextArrow: $(".slider-arrow--next_collection"),
    prevArrow: $(".slider-arrow--prev_collection")

  });


}

// JavaScript logic for hamburger menu added on 2024-12-10

document.addEventListener('DOMContentLoaded', () => {
    const hamburger = document.querySelector('.hamburger-menu');
    const mobileMenu = document.querySelector('.mobile-menu');

    if (hamburger && mobileMenu) {
        hamburger.addEventListener('click', (e) => {
            e.preventDefault(); 
            e.stopPropagation(); 

            console.log('Hamburger clicked'); // Debugging log

            hamburger.classList.toggle('is-open');
            mobileMenu.classList.toggle('active');

            console.log('Mobile Menu state:', mobileMenu.classList.contains('active')); // Debugging log
        });
    }

    document.querySelectorAll('a[href="#"]').forEach(anchor => {
        anchor.addEventListener('click', (event) => {
            event.preventDefault(); 
        });
    });
});




